import { jsx, jsxs } from "react/jsx-runtime";
import { MenuItem, Select, Stack, Typography } from "@mui/material";
function FontWeightInput(props) {
  const { value, onChange, title, options } = props;
  return /* @__PURE__ */ jsx(Stack, { flex: "1 1 auto", children: /* @__PURE__ */ jsxs(Stack, { alignItems: "center", direction: "row", children: [
    /* @__PURE__ */ jsxs(
      Typography,
      {
        sx: (theme) => ({
          color: theme.vars.palette.text.secondary,
          flex: "1 1 auto",
          fontSize: 16
        }),
        children: [
          title,
          ":"
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      Select,
      {
        onChange: (event) => {
          const value2 = event.target.value;
          onChange(typeof value2 === "string" ? Number.parseInt(value2, 10) : value2);
        },
        size: "small",
        sx: { height: 28 },
        value,
        children: options.map((t) => /* @__PURE__ */ jsx(MenuItem, { value: t, children: t }, t))
      }
    )
  ] }) });
}
export {
  FontWeightInput
};
//# sourceMappingURL=FontWeightInput.js.map
